import { ViewType, ViewObject } from '../base';

import { dataService } from '../../data';
import { PayAccount } from '../objects/payaccount';

import { PlaceView } from './place';

/****************************/
/* CLASS VIEW               */
/****************************/

export class _PayAccountView extends ViewObject<PayAccount> {

    /**********************************/
    /* VIEWOBJECT IMPLEMENTATION      */
    /**********************************/

    private get payaccount(): PayAccount{
        return this.object;
    }

    constructor(object: PayAccount, data: dataService){
        super(object, data);
    }

    /**********************************/
    /* VIEW MANAGED INFORMATION       */
    /**********************************/

    private RefreshView(targets: string[]){
        let _viewReload = false;

        if (targets.includes('PAYACCOUNT')){
            _viewReload = true;
        }

        if (targets.includes('INVOICEBUSINESS')){
            this.DoRefreshView();
        }

        if (targets.includes('ACCOUNTINVOICE')){
            _viewReload = true;
        }

        if (targets.includes('TICKET')){
            _viewReload = true;
        }

        if (_viewReload){
            this.DoRefreshView();
        }
    }

    /**********************************/
    /* CHILDREN REGISTRATION          */
    /**********************************/

    override doRegister(): void{
        const weakref = new WeakRef(this);

        for (const _subsription of this._subscriptions){
            _subsription.unsubscribe();
        }
        this._subscriptions = [];

        this._subscriptions.push(
            this.payaccount.OnChildChanged.subscribe(() => {
                const self = weakref.deref();
                if (self) self.doRegister();
            })
        );

        this._subscriptions.push(
            this.payaccount.OnRefresh.subscribe(
            (targets: string[]) => {
                const self = weakref.deref();
                if (self){
                    self.RefreshView(targets);
                }
            })
        );

        const _client = this.payaccount.client;
        if (_client){
            this._subscriptions.push(
                _client.OnRefresh.subscribe(
                (targets: string[]) => {
                    const self = weakref.deref();
                    if (self){
                        self.RefreshView(targets);
                    }
                })
            );
        }
    }

    /**********************************/
    /* ACTIVE CHILDREN INFORMATION    */
    /**********************************/

    get place(): PlaceView | null {
        return this.data.alives.get(this.payaccount.place) as PlaceView;
    }
}

/****************************/
/* PROXY VIEW               */
/****************************/

export type PayAccountView = ViewType <_PayAccountView, PayAccount>;

export function PayAccountViewProxy(object: PayAccount, data: dataService): PayAccountView {
    return new _PayAccountView(object, data).Proxy as PayAccountView;
}
